import { traceQuery, useDeleteTraceMutation } from "@common/api"
import { handleError } from "@common/utils"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { DeleteTraceDialog } from "@/routes/_layout/agent/-components/delete-trace-dialog"
import { usePinnedTraces } from "./-lib/pinned-traces"

export const Route = createFileRoute("/_layout/agent/chats/delete/$id")({
  component: DeleteChatModal,
})

function DeleteChatModal(): React.ReactElement {
  const { id } = Route.useParams()
  const navigate = useNavigate({ from: Route.fullPath })
  const showToast = useCustomToast()
  const { removePinned } = usePinnedTraces()
  const { data: trace } = useQuery(traceQuery({ id }))
  const deleteMutation = useDeleteTraceMutation()
  const close = () => navigate({ to: "/agent/chats", search: true })

  const handleConfirm = () => {
    deleteMutation.mutate(
      { id },
      {
        onSuccess: () => {
          removePinned(id)
          showToast(
            "Chat deleted",
            "The chat was permanently deleted.",
            "success",
          )
          close()
        },
        onError: (err) => handleError(err, showToast),
      },
    )
  }

  return (
    <DeleteTraceDialog
      open
      onOpenChange={(open) => !open && close()}
      trace={trace ?? null}
      isDeleting={deleteMutation.isPending}
      onConfirm={handleConfirm}
    />
  )
}
